import { IconText } from "./Icon";
import { Button } from "react-bulma-components";
import React, { useState } from "react";
import { UilSpinner } from "@iconscout/react-unicons";

export default function LoadableButton({ children, color, icon, onClick }) {
    const [loading, setLoading] = useState(false);

    const onClickReal = async () => {
        setLoading(true);

        try {
            await onClick();
        } catch (e) {
            // TODO
        } finally {
            setLoading(false);
        }
    }

    const iconReal = loading
        ? UilSpinner
        : icon;

    return (
        <Button color={ color } disabled={ loading } onClick={ onClickReal }>
            <IconText icon={ iconReal } spin={ loading }>
                { children }
            </IconText>
        </Button>
    )
}